import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  AddOrUpdateHistoricQuoteParams,
  ApiException,
  buildHistoricQuotesApiWithToken,
} from "@bn/api/apiv1";

export const useAddOrUpdateHistoricQuotes = (
  options: UseMutationOptions<
    unknown,
    AxiosError<ApiException>,
    AddOrUpdateHistoricQuoteParams
  > = {}
) => {
  return useMutation({
    mutationFn: async (params: AddOrUpdateHistoricQuoteParams) => {
      const historicApi = await buildHistoricQuotesApiWithToken();
      return historicApi.addOrUpdateHistoricQuotes({
        addOrUpdateHistoricQuoteParams: params,
      });
    },
    ...options,
  });
};
